import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { formatDate, parseNumberString } from "./utils";

const FONT = { name: "Calibri", size: 10 };
const FONT_BOLD = { ...FONT, bold: true };

function toNumeric(val) {
  if (val == null || val === "") return 0;
  if (typeof val === "number" && !Number.isNaN(val)) return val;
  return parseNumberString(String(val)) || 0;
}

class ExportPurchaseReport {
  async execute(client, purchases, filename) {
    try {
      const workbook = new ExcelJS.Workbook();

      /* ===== Sheet 1 ===== */
      const sheet1 = workbook.addWorksheet("Sheet 1");

      for (let i = 1; i <= 50; i++) {
        const col = sheet1.getColumn(i);
        col.width = 40;
        col.style = { font: FONT };
      }
      const clientAdress = [
        client?.billingRegion,
        client?.billingProvince,
        client?.billingCity,
        client?.billingBarangay,
        client?.billingStreet,
      ]
        .filter(Boolean)
        .join(", ");

      sheet1.getCell("A1").value = "PURCHASE TRANSACTION";
      sheet1.getCell("A1").font = FONT_BOLD;
      sheet1.getCell("A1").alignment = {
        vertical: "middle",
        horizontal: "left",
      };

      sheet1.mergeCells("A2:B2");
      sheet1.getCell("A2").value = "RECONCILIATION OF LISTING FOR ENFORCEMENT";
      sheet1.getCell("A2").alignment = { horizontal: "left" };
      sheet1.getCell("A2").font = FONT_BOLD;

      sheet1.getCell("A6").value = `TIN: ${client?.tinNo || "N/A"}`;
      sheet1.getCell("A6").font = FONT_BOLD;
      sheet1.getCell("A6").alignment = { horizontal: "left" };

      sheet1.mergeCells("A7:C7");

      sheet1.getCell("A7").alignment = { horizontal: "left" };
      sheet1.getCell("A7").font = FONT_BOLD;
      sheet1.getCell("A7").value =
        `OWNER'S NAME: ${client?.name || client?.name}`;

      sheet1.mergeCells("A8:C8");
      sheet1.getCell("A8").value =
        `OWNER'S TRADE NAME: ${client?.companyName || client?.name}`;
      sheet1.getCell("A8").font = FONT_BOLD;
      sheet1.getCell("A8");
      sheet1.getCell("A8").alignment = { horizontal: "left" };

      sheet1.getCell("A9:E9");
      sheet1.getCell("A9").value = `OWNER'S ADDRESS: ${clientAdress}`;
      sheet1.getCell("A9").font = FONT_BOLD;

      const headerRow1 = sheet1.getRow(11);
      [
        "TAXABLE",
        "TAX PAYER",
        "REGISTERED NAME",
        "NAME OF SUPPLIER",
        "SUPPLIER'S ADDRESS",
        "AMOUNT OF",
        "AMOUNT OF",
        "AMOUNT OF",
        "AMOUNT OF",
        "AMOUNT OF",
        "AMOUNT OF",
        "AMOUNT OF",
        "AMOUNT OF",
        "AMOUNT OF",
      ].forEach((text, i) => {
        const cell = headerRow1.getCell(i + 1);
        cell.value = text;
        cell.font = FONT_BOLD;
        cell.alignment = { horizontal: "left", vertical: "middle" };
      });

      const headerRow2 = sheet1.getRow(12);
      [
        "MONTH",
        "IDENTIFICATION",
        "",
        "(Last Name, First Name, Middle Name)",
        "",
        "GROSS PURCHASE",
        "EXEMPT PURCHASE",
        "ZERO-RATED PURCHASE",
        "TAXABLE PURCHASE",
        "PURCHASE OF SERVICES",
        "PURCHASE OF CAPITAL GOODS",
        "PURCHASE OF GOODS OTHER THAN CAPITAL GOODS",
        "INPUT TAX",
        "GROSS TAXABLE PURCHASE",
      ].forEach((text, i) => {
        const cell = headerRow2.getCell(i + 1);
        cell.value = text;
        cell.font = FONT_BOLD;
        cell.alignment = { horizontal: "left", vertical: "middle" };
      });

      const headerRow3 = sheet1.getRow(13);
      ["", "NUMBER"].forEach((text, i) => {
        const cell = headerRow3.getCell(i + 1);
        cell.value = text;
        cell.font = FONT_BOLD;
        cell.alignment = { horizontal: "left", vertical: "middle" };
      });

      const headerRow4 = sheet1.getRow(14);
      [
        "(1)",
        "(2)",
        "(3)",
        "(4)",
        "(5)",
        "(6)",
        "(7)",
        "(8)",
        "(9)",
        "(10)",
        "(11",
        "(12)",
        "(13)",
        "(14)",
      ].forEach((text, i) => {
        const cell = headerRow4.getCell(i + 1);
        cell.value = text;
        cell.font = FONT_BOLD;
        cell.alignment = { horizontal: "left", vertical: "middle" };
      });

      let rowNumber = 15;
      purchases.forEach((obj) => {
        const row = sheet1.getRow(rowNumber);
        row.values = [
          formatDate(obj.taxableDate),
          obj.supplier.tinNo || "N/A",
          obj.supplier.name || "",
          obj.fullName || "",
          obj.address || "",
          toNumeric(obj.totalGross),
          toNumeric(obj.vatExemptAmount),
          toNumeric(obj.zeroRatedAmount),
          toNumeric(obj.taxableAmount),
          toNumeric(obj.servicesAmount),
          toNumeric(obj.capitalGoodsAmount),
          toNumeric(obj.otherGoodsAmount),
          toNumeric(obj.vatAmount),
          toNumeric(obj.grossTaxableAmount),
        ];

        for (let col = 1; col <= 14; col++) {
          const cell = row.getCell(col);
          cell.alignment = {
            horizontal: col >= 2 && col <= 5 ? "left" : "right",
            vertical: "middle",
          };
          if (col >= 6) {
            cell.numFmt = "#,##0.00";
          }
        }

        rowNumber++;
      });

      let rowTotal = rowNumber + 3;
      sheet1.getCell(`A${rowTotal}`).value = "Grand Total:";
      sheet1.getCell(`A${rowTotal}`).alignment = { horizontal: "left" };

      for (let col = 6; col <= 14; col++) {
        const colLetter = String.fromCharCode(64 + col);
        const cell = sheet1.getCell(rowTotal, col);
        cell.value = {
          formula: `SUM(${colLetter}15:${colLetter}${rowNumber - 1})`,
        };
        cell.numFmt = "#,##0.00";
        cell.font = FONT_BOLD;
      }

      sheet1.getCell(`A${rowTotal + 2}`).value = "END OF REPORT";
      sheet1.getCell(`A${rowTotal + 2}`).alignment = { horizontal: "left" };

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, filename);
    } catch (error) {
      console.error("Error generating Excel:", error);
      throw error;
    }
  }
}

export default ExportPurchaseReport;
